import React from "react";
import { useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import Button from "components/Elements/Button/Button.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import parse from "html-react-parser";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import PurchaseSubUsersModal from "../../SubUsers/Modals/PurchaseSubUsersModal.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";
import { Toggle } from "components/Elements/Toggle/Toggle.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import UpgradeToBusinessModal from "./UpgradeToBusinessModal.js";

const SubUsersManagementDetails = ({ userData }) => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();
  const { isPro } = useUser();

  const tooltipText = parse(
    getTextByKey("myprofile-sub-user-management-tooltip")
  );

  const maxProgressBar = userData.UserTotalSubUsersLicenses;
  const usedProgressBar =
    userData.UserTotalSubUsersLicenses - userData.UserAvailableSubUsersLicenses;

  const doesUserHasAnySubUsers = userData.UserTotalSubUsersLicenses > 0;

  const availableSubUserText =
    userData.UserTotalSubUsersLicenses === 0
      ? userData.UserAvailableSubUsersLicenses +
        ` ${getTextByKey("profileuser-sub-user-licenses-available")}`
      : `${getTextByKey(
          "profileuser-sub-user-assigned-licenses"
        )} ${usedProgressBar}/${maxProgressBar}`;

  const percantegeOfSpace = Math.round(
    (usedProgressBar / maxProgressBar) * 100
  );

  const [subUserSetBranding, setSubUserSetBranding] = useState(
    userData.SubUserSetBranding
  );
  const [loading, setLoading] = useState(false);

  const changeTopUserSetBranding = async () => {
    const parameters = {
      subUserSetBranding: !subUserSetBranding,
    };

    setLoading(true);
    const response = await apiRequest(
      "SubUsers",
      "ChangeUserSetBranding",
      parameters,
      "POST"
    );

    if (response.status === "success") {
      setSubUserSetBranding(!subUserSetBranding);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const openPurchaseSubUsers = () => {
    setModal(() => <PurchaseSubUsersModal userData={userData} />);
  };

  const newPremiumModal = () => {
    setModal({
      modal: UpgradeToBusinessModal,
    });
  };

  const purchaseSubUserButton = () => {
    if (isPro()) {
      return (
        <Button
          blank
          small
          className="buy-licenses-button"
          onClick={newPremiumModal}
        >
          {doesUserHasAnySubUsers
            ? getTextByKey("myprofile-sub-user-management-buy-licenses-button")
            : getTextByKey(
                "myprofile-sub-user-management-buy-only-licenses-button"
              )}
        </Button>
      );
    } else {
      return (
        <Button blank small className="buy-licenses-button">
          <LinkToNewTab page={"purchase/sub-users"} isNewTab>
            {doesUserHasAnySubUsers
              ? getTextByKey(
                  "myprofile-sub-user-management-buy-licenses-button"
                )
              : getTextByKey(
                  "myprofile-sub-user-management-buy-only-licenses-button"
                )}
          </LinkToNewTab>
        </Button>
      );
    }
  };

  return (
    <div className="sub-user-management-container">
      <div className="icon">
        <Icon name="sub-users-image" iconClass="sub-user-image" ext="png" xl />
      </div>
      <div className="title">
        {getTextByKey("myprofile-sub-user-management-title")}
        <Tooltip
          clickable
          tooltipTextKey={tooltipText}
          top
          className={"sub-users-tooltip"}
        >
          <div className="sub-users-tooltip-icon-container">
            <Icon name="question-circle" iconClass="sub-users-tooltip-icon" />
          </div>
        </Tooltip>
      </div>
      <div className="available-sub-users">{availableSubUserText}</div>
      {doesUserHasAnySubUsers && (
        <div className="progressbar">
          <div
            className={`progress-fill ${maxProgressBar > 0 ? "complete" : ""}`}
            style={{
              width: `${
                maxProgressBar > 0
                  ? usedProgressBar > maxProgressBar
                    ? 100
                    : (usedProgressBar / maxProgressBar) * 100
                  : 0
              }%`,
              backgroundColor: `${"#51c7df"}`,
            }}
          ></div>
        </div>
      )}
      <div className="add-licenses-button">{purchaseSubUserButton()}</div>
      {loading ? (
        <div className="loading-sub-user-set-branding-container">
          <LoadingImageElement />
        </div>
      ) : !isPro() && userData.subUsersCount > 0 ? (
        <div className="set-sub-user-branding">
          {/* tooltip */}
          <Toggle
            status={subUserSetBranding}
            setStatus={() => changeTopUserSetBranding()}
          />
          {getTextByKey("myprofile-sub-user-management-set-branding")}
          <Tooltip
            end
            tooltipTextKey={getTextByKey(
              "myprofile-sub-user-management-set-branding-tooltip"
            )}
            className={"sub-users-tooltip"}
          >
            <div className="sub-users-tooltip-icon-container">
              <Icon name="question-circle" iconClass="sub-users-tooltip-icon" />
            </div>
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
};

export default SubUsersManagementDetails;
